import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cf9f17a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "職歴の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "会社名・団体名"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_5 = { class: "careersheet_input_layout_column_1" }
const _hoisted_6 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_7 = { class: "careersheet_input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "業種"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/102",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）業種一覧 ")
], -1))
const _hoisted_9 = { class: "careersheet_input_layout_column_1" }
const _hoisted_10 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_11 = { class: "careersheet_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "社員数")
], -1))
const _hoisted_13 = { class: "careersheet_input_layout_column_2" }
const _hoisted_14 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_15 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_16 = { class: "careersheet_input_layout_column_2_item_inner_select" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_layout_column_2_item_inner_suffix_text" }, "人")
], -1))
const _hoisted_18 = { class: "careersheet_input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "在籍期間"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "careersheet_enrollment_period_text" }, "※現職中の場合、終了年月は空欄のままにしてください")
], -1))
const _hoisted_21 = { class: "careersheet_input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "職種（3つまで選択できます）"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/101",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）職種一覧 ")
], -1))
const _hoisted_23 = { class: "careersheet_input_layout_column_1" }
const _hoisted_24 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_25 = { class: "careersheet_input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "雇用形態"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_27 = { class: "careersheet_input_layout_column_2" }
const _hoisted_28 = { class: "careersheet_input" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "役職")
], -1))
const _hoisted_30 = { class: "careersheet_input_layout_column_1" }
const _hoisted_31 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_32 = { class: "careersheet_input" }
const _hoisted_33 = { class: "input_title" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "年収", -1))
const _hoisted_35 = {
  key: 0,
  class: "input_title_required"
}
const _hoisted_36 = { class: "careersheet_input_layout_column_2" }
const _hoisted_37 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_38 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_39 = { class: "careersheet_input_layout_column_2_item_inner_select" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_layout_column_2_item_inner_suffix_text" }, "万円")
], -1))
const _hoisted_41 = { class: "careersheet_input" }
const _hoisted_42 = { class: "input_title" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "月収", -1))
const _hoisted_44 = {
  key: 0,
  class: "input_title_required"
}
const _hoisted_45 = { class: "careersheet_input_layout_column_2" }
const _hoisted_46 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_47 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_48 = { class: "careersheet_input_layout_column_2_item_inner_select" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_layout_column_2_item_inner_suffix_text" }, "万円")
], -1))
const _hoisted_50 = { class: "careersheet_input" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "職務内容（2000文字まで）")
], -1))
const _hoisted_52 = { class: "careersheet_input_layout_column_1" }
const _hoisted_53 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_54 = { class: "careersheet_button" }
const _hoisted_55 = { class: "careersheet_button_prev" }
const _hoisted_56 = { class: "careersheet_button_next" }

import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseSelectButton from '@/components/BaseSelectButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseYmForm from '@/components/BaseYmForm.vue';
import EditRadioModal from '@/components/EditRadioModal.vue';
import EditCheckboxModal from '@/components/EditCheckboxModal.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { RadioListType, CheckboxListType } from '@/types';
import { ref, Ref, computed, watchEffect } from 'vue';
import Loading from '@/components/Loading.vue';
import { useRouter, useRoute } from 'vue-router';
import { EditingWorkHistoryDetailInfo } from '@/types';
import store from '@/store';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import { ymHyphenFormat, numberToDate } from '@/utils/dateFormat';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyEditView',
  setup(__props) {

const { meta } = useForm();
const route = useRoute();
const router = useRouter();
const isLoading = ref(false);
const shownIndsctgModal = ref(false);
const shownBusicrOcupctgModal = ref(false);

const busicrId = computed(() => {
  return store.getters['workHistory/editingBusicrId'];
});
const mstIndsctg = computed(() => {
  return store.getters['master/mstIndsctg'];
});
const mstOcupClass = computed(() => {
  return store.getters['master/mstOcupClass'];
});
const mstEmpTypeBusicr = computed(() => {
  return store.getters['master/mstEmpTypeBusicr'];
});
const isMostRecent = computed(() => {
  return store.getters['workHistory/isMostRecent'];
});

const workHistoryDetailInfo: EditingWorkHistoryDetailInfo = store.getters['workHistory/editingWorkHistoryDetailInfo'];

const { value: compname, errors: compnameErrors } = useField<string>('compname', validationRuleHelper({ required: true, max: 50 }), {
  initialValue: workHistoryDetailInfo.compname,
  bails: false,
  label: '会社名・団体名',
});

const { value: indsctgId, errors: indsctgIdErrors } = useField<number | null>('indsctgId', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.indsctgId,
  bails: false,
  label: '業種',
});

const indsctgName = ref('');
const mstIndsctgFlat: Ref<{ [key: number]: string }> = computed(() => {
  return store.getters['master/mstIndsctgFlat'];
});
const indsctgList: Ref<RadioListType[]> = computed(() => {
  return store.getters['master/mstIndsctgRadioOnlyList'];
});

const { value: employeeNum, errors: employeeNumErrors } = useField<string>(
  'employeeNum',
  validationRuleHelper({ betweenValue: [1, 999999] }),
  {
    initialValue: workHistoryDetailInfo.employeeNum,
    bails: false,
    label: '社員数',
  }
);

const { value: wkperiodsDate, errors: wkperiodsDateErrors } = useField<string>(
  'wkperiodsDate',
  validationRuleHelper({ required: true, ym: true }),
  {
    initialValue:
      !workHistoryDetailInfo.wkperiodsDateyr || !workHistoryDetailInfo.wkperiodsDatemon
        ? ''
        : ymHyphenFormat(numberToDate(Number(workHistoryDetailInfo.wkperiodsDateyr), Number(workHistoryDetailInfo.wkperiodsDatemon))),
    bails: false,
    label: '在籍期間(開始年月)',
  }
);

const { value: wkperiodeDate, errors: wkperiodeDateErrors } = useField<string>('wkperiodeDate', validationRuleHelper({ ym: true }), {
  initialValue:
    !workHistoryDetailInfo.wkperiodeDateyr || !workHistoryDetailInfo.wkperiodeDatemon
      ? ''
      : ymHyphenFormat(numberToDate(Number(workHistoryDetailInfo.wkperiodeDateyr), Number(workHistoryDetailInfo.wkperiodeDatemon))),
  bails: false,
  label: '在籍期間(終了年月)',
});

const busicrOcupctgIdArray = ref(
  [workHistoryDetailInfo.busicrOcupctg1Id, workHistoryDetailInfo.busicrOcupctg2Id, workHistoryDetailInfo.busicrOcupctg3Id]
    .filter((i) => {
      return i !== null && i !== undefined && i !== '';
    })
    .map((i) => String(i))
);

const { value: busicrOcupctgName, errors: busicrOcupctgNameErrors } = useField<string>(
  'busicrOcupctgName',
  validationRuleHelper({ required: true }),
  {
    initialValue: '',
    bails: false,
    label: '職種',
  }
);

const mstOcupClassFlat: Ref<{ [key: number]: string }> = computed(() => {
  return store.getters['master/mstOcupClassFlat'];
});
const mstOcupClassList: Ref<CheckboxListType[]> = computed(() => {
  return store.getters['master/mstOcupClassCheckboxList'];
});

const { value: emptypeId, errors: emptypeIdErrors } = useField<number>('emptypeId', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.emptypeId,
  bails: false,
  label: '雇用形態',
});
const { value: post, errors: postErrors } = useField<string>('post', validationRuleHelper({ max: 25 }), {
  initialValue: workHistoryDetailInfo.post,
  bails: false,
  label: '役職',
});
// 年収 月収は職歴indexでバリデーションルールを変更する
let validationAnnualincmAndSalary = {};
if (isMostRecent.value) {
  validationAnnualincmAndSalary = { required: true, betweenValue: [1, 9999] };
} else {
  validationAnnualincmAndSalary = { betweenValue: [1, 9999] };
}

const { value: annualincm, errors: annualincmErrors } = useField<string>(
  'annualincm',
  validationRuleHelper(validationAnnualincmAndSalary),
  {
    initialValue: workHistoryDetailInfo.annualincm,
    bails: false,
    label: '年収',
  }
);
const { value: salary, errors: salaryErrors } = useField<string>('salary', validationRuleHelper(validationAnnualincmAndSalary), {
  initialValue: workHistoryDetailInfo.salary,
  bails: false,
  label: '月収',
});
const { value: wkcontents, errors: wkcontentsErrors } = useField<string>('wkcontents', validationRuleHelper({ max: 2000 }), {
  initialValue: workHistoryDetailInfo.wkcontents,
  bails: false,
  label: '職務内容',
});

// 業種名、職種名の更新
watchEffect(() => {
  indsctgName.value = indsctgId.value === null ? '' : mstIndsctgFlat.value[indsctgId.value] || '';
  busicrOcupctgName.value = busicrOcupctgIdArray.value.map((i) => mstOcupClassFlat.value[Number(i)]).join('、');
});

const init = async () => {
  isLoading.value = true;
  try {
    await Promise.all([
      store.dispatch('master/getMasterDataListEmpTypeBusicr'),
      store.dispatch('master/getMasterDataListIndsctg'),
      store.dispatch('master/getMasterDataOcupClass'),
    ]);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const openIndsctgModal = () => {
  shownIndsctgModal.value = true;
};
const closeIndsctgModal = () => {
  shownIndsctgModal.value = false;
};
const clearIndsctgId = () => {
  indsctgId.value = null;
};

const openBusicrOcupctgModal = () => {
  shownBusicrOcupctgModal.value = true;
};
const closeBusicrOcupctgModal = () => {
  shownBusicrOcupctgModal.value = false;
};
const clearBusicrOcupctg = () => {
  busicrOcupctgIdArray.value = [];
};

const newWorkHistoryDetailInfo = computed(() => {
  return {
    busicrId: busicrId.value,
    compname: compname.value,
    indsctgId: indsctgId.value,
    employeeNum: employeeNum.value,
    wkperiodsDateyr: Number(wkperiodsDate.value.split('-')[0]),
    wkperiodsDatemon: Number(wkperiodsDate.value.split('-')[1]),
    wkperiodeDateyr: wkperiodeDate.value.split('-')[0] ? Number(wkperiodeDate.value.split('-')[0]) : null,
    wkperiodeDatemon: wkperiodeDate.value.split('-')[1] ? Number(wkperiodeDate.value.split('-')[1]) : null,
    busicrOcupctg1Id: busicrOcupctgIdArray.value[0] || '',
    busicrOcupctg2Id: busicrOcupctgIdArray.value[1] || '',
    busicrOcupctg3Id: busicrOcupctgIdArray.value[2] || '',
    emptypeId: emptypeId.value,
    post: post.value,
    annualincm: annualincm.value,
    salary: salary.value,
    wkcontents: wkcontents.value,
  };
});

const transitionConfirmPage = () => {
  store.commit('workHistory/setEditingWorkHistoryDetailInfo', newWorkHistoryDetailInfo.value);
  if (route.query.ref === 'e') {
    router.push({ name: 'e36', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e36' });
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e33', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e33' });
  }
};

if (!mstIndsctg.value || !mstOcupClass.value || !mstEmpTypeBusicr.value) {
  init();
}

if (!busicrId.value) {
  transitionPreviousPage();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseTextForm, {
              isError: _unref(compnameErrors).length > 0,
              placeholder: "会社名・団体名",
              modelValue: _unref(compname),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(compname) ? (compname).value = $event : null)),
              maxlength: 50
            }, null, 8, ["isError", "modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(compnameErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseSelectButton, {
              placeholder: "業種を選択",
              modelValue: indsctgName.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((indsctgName).value = $event)),
              onClick: openIndsctgModal,
              onClear: clearIndsctgId
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(indsctgIdErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(BaseTextForm, {
                  isError: _unref(employeeNumErrors).length > 0,
                  placeholder: "社員数を入力",
                  modelValue: _unref(employeeNum),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(employeeNum) ? (employeeNum).value = $event : null)),
                  maxlength: 6
                }, null, 8, ["isError", "modelValue"])
              ]),
              _hoisted_17
            ])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(employeeNumErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(BaseYmForm, {
          modelValue: _unref(wkperiodsDate),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(wkperiodsDate) ? (wkperiodsDate).value = $event : null)),
          suffixYearText: "年",
          suffixMonthText: "月から",
          hasCancelButton: true,
          yearSort: "desc"
        }, null, 8, ["modelValue"]),
        _createVNode(BaseYmForm, {
          modelValue: _unref(wkperiodeDate),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(wkperiodeDate) ? (wkperiodeDate).value = $event : null)),
          suffixYearText: "年",
          suffixMonthText: "月まで",
          hasCancelButton: true,
          yearSort: "desc"
        }, null, 8, ["modelValue"]),
        _hoisted_20
      ]),
      _createVNode(ErrorMessage, { errors: _unref(wkperiodsDateErrors) }, null, 8, ["errors"]),
      _createVNode(ErrorMessage, { errors: _unref(wkperiodeDateErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(BaseSelectButton, {
              placeholder: "職種を選択",
              modelValue: _unref(busicrOcupctgName),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(busicrOcupctgName) ? (busicrOcupctgName).value = $event : null)),
              onClick: openBusicrOcupctgModal,
              onClear: clearBusicrOcupctg
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(busicrOcupctgNameErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mstEmpTypeBusicr), (employment) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "careersheet_input_layout_column_2_item",
              key: employment.code
            }, [
              _createVNode(BaseRadioButton, {
                label: employment.name,
                value: employment.code,
                modelValue: _unref(emptypeId),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(emptypeId) ? (emptypeId).value = $event : null))
              }, null, 8, ["label", "value", "modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(emptypeIdErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(BaseTextForm, {
              isError: _unref(postErrors).length > 0,
              placeholder: "役職を入力",
              modelValue: _unref(post),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(post) ? (post).value = $event : null)),
              maxlength: 25
            }, null, 8, ["isError", "modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(postErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          (_unref(isMostRecent))
            ? (_openBlock(), _createElementBlock("span", _hoisted_35, "必須"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(BaseTextForm, {
                  isError: _unref(annualincmErrors).length > 0,
                  placeholder: "年収を入力",
                  modelValue: _unref(annualincm),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(annualincm) ? (annualincm).value = $event : null)),
                  maxlength: 4
                }, null, 8, ["isError", "modelValue"])
              ]),
              _hoisted_40
            ])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(annualincmErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          (_unref(isMostRecent))
            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "必須"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(BaseTextForm, {
                  isError: _unref(salaryErrors).length > 0,
                  placeholder: "月収を入力",
                  modelValue: _unref(salary),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(salary) ? (salary).value = $event : null)),
                  maxlength: 4
                }, null, 8, ["isError", "modelValue"])
              ]),
              _hoisted_49
            ])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(salaryErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createVNode(BaseTextareaForm, {
              name: "wkcontents",
              rows: 10,
              maxCount: 2000,
              placeholder: "入力してください",
              modelValue: _unref(wkcontents),
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(wkcontents) ? (wkcontents).value = $event : null))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(wkcontentsErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            type: "button",
            onClick: transitionPreviousPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createVNode(BaseButton, {
            theme: "primary",
            type: "button",
            disabled: !_unref(meta).valid,
            onClick: transitionConfirmPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("確認する")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    (shownIndsctgModal.value)
      ? (_openBlock(), _createBlock(EditRadioModal, {
          key: 0,
          title: "業種選択",
          modelValue: _unref(indsctgId),
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(indsctgId) ? (indsctgId).value = $event : null)),
          list: _unref(indsctgList),
          onClose: closeIndsctgModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true),
    (shownBusicrOcupctgModal.value)
      ? (_openBlock(), _createBlock(EditCheckboxModal, {
          key: 1,
          title: "職種選択",
          modelValue: busicrOcupctgIdArray.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((busicrOcupctgIdArray).value = $event)),
          selectableMinNumber: 1,
          selectableMaxNumber: 3,
          hasNextPageType: true,
          list: _unref(mstOcupClassList),
          onClose: closeBusicrOcupctgModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})